import React, { CSSProperties } from 'react'
import Avatar, { ugcUserLink, IProps as IAvatarProps } from './avatar'
import { stopPropagation } from 'Components/new/community-card/interact'
import styleModule from './author-avatar.module.scss'

export interface IProps extends IAvatarProps {
  onClick?: () => void
  textColor?: string
  style?: CSSProperties
}

const AuthorAvatar: React.FC<IProps> = ({
  onClick,
  textColor = '#1f2129',
  style,
  userId,
  username,
  userVerified,
  verifyType,
  avatar,
}) => {
  return (
    <div className={styleModule['avatar-wrap']} style={style}>
      <Avatar
        onClick={stopPropagation(onClick)}
        userId={userId}
        username={username}
        userVerified={userVerified}
        verifyType={verifyType}
        avatar={avatar}
      />
      {username ? (
        <p
          className={`${styleModule['name']} name line-1`}
          onClick={(e) => {
            e.stopPropagation()
            if (onClick) onClick()
          }}
          title={username}
        >
          {ugcUserLink({ userId, username })(username)}
        </p>
      ) : null}
      <style jsx>
        {`
          .name {
            color: ${textColor};
          }
        `}
      </style>
    </div>
  )
}

export default AuthorAvatar
